import { useState } from "react";
import {
  Col,
  Container,
  Modal,
  Row,
  Button,
  FloatingLabel,
  Form,
} from "react-bootstrap";
import NavBar from "../../Navbar/Navbar";
import "./ChildDevelopment.css";
import Footer from "../../Footer/Footer";
import YouTube, { YouTubeProps } from "react-youtube";
import Chart from "../../../assets/img/Applied-Arts2.png";
import { Helmet } from "react-helmet";
export default function ChildDevelopment() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const onPlayerReady = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };
  const opts = {
    height: "590",
    width: "100%",
    playerVars: {
      autoplay: true,
    },
  };
  return (
    <>
      <Helmet>
        <title>
          Child Skills Development | Manzil Center -Special Families Support
        </title>
        <meta
          name="description"
          content="Manzil students who are enrolled in the training program have access to the following services: Numeracy Enhancement, Communication Skills, etc."
        />
        <meta
          name="keywords"
          content="Manzil center, Special Family Support, Child skills development, special need school, Autism Center in Sharjah, NGO in Sharjah, Sharjah, UAE, special EMPLOYMENT PROGRAM in sharjah"
        />
        <link
          rel="canonical"
          href="https://www.manzil.ae/child-skill-development"
        />
        <meta
          property="og:title"
          content="Child Skills Development | Manzil Center -Special Families Support"
        />
        <meta
          property="og:description"
          content="Manzil students who are enrolled in the training program have access to the following services: Numeracy Enhancement, Communication Skills, etc."
        />
        <meta
          property="og:url"
          content="https://www.manzil.ae/child-skill-development"
        />
        <meta
          property="og:image"
          content="https://www.manzil.ae/static/media/Applied-Arts2.3e5603f92264d116fb7b.png"
        />
        <meta
          name="twitter:title"
          content="Child Skills Development | Manzil Center -Special Families Support"
        />
        <meta
          name="twitter:description"
          content="Manzil students who are enrolled in the training program have access to the following services: Numeracy Enhancement, Communication Skills, etc."
        />
        <meta
          name="twitter:image"
          content="https://www.manzil.ae/static/media/Applied-Arts2.3e5603f92264d116fb7b.png"
        />
      </Helmet>
      <NavBar />
      <div className="page-title-area child-inner">
        <div className="container-fluid h-100 d-flex justify-content-center align-items-center">
          <div className="page-title-content">
            <ul>
              {/* <li>
                <a href="/">Home</a>
              </li> */}
              <li>
                <h1>Child Skill Development</h1>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Container className="mt-4 pt-2">

        <Row>
          <Col lg={12} className="text-center">
            <div className="main-heading">
              {/* <span className="center">Child Skill Development</span> */}
              {/* <p>
                Every student at Manzil follows an individual learning plan
                (ILP). The training program follows a holistic approach
                comprising development of emotional intelligence, academic,
                self-help, cognitive, social, and motor skills primarily through
                the medium of art
              </p> */}
              <p className="mb-0">Empowering learners under 16 with inclusive, creative, and personalised growth journeys. Led by a multidisciplinary team, the program is delivered through individual (1:1) or group-based sessions, with every student following a tailored Individual Learning Plan (ILP). Each ILP integrates therapeutic strategies and real-world learning to develop emotional intelligence, functional academics, self-help, cognitive, social, and motor skills delivered holistically through <b>art therapy</b>, life skills, and naturalistic experiences. This program is one of the finest <b>vocational training courses</b> designed to cater to the unique needs of each student.</p>
            </div>
          </Col>
          {/* <Col lg={12}>
            <div className="main-heading mt-5">
              <span>Manzil Art Collection</span>

              <p>
                Manzil Art Collection displayed in prestigious art studio and
                hotels in Dubai
              </p>
            </div>
          </Col> */}
          <Col lg={12}>
            <div className="main-heading text-center mt-5">
              <span className="center">Services</span>

              {/* <p>
                Manzil students who are enrolled in the training program have
                access to the following services :
              </p> */}
              <p>Manzil students who are enrolled in the <b>Child Skill Development Training program</b> have access to the following services :</p>

            </div>
            <div>
              <ul className="mb-0">
                <li><b>Independent Living Skills</b>: Training to build independence in daily living.</li>
                <li><b>Communication Skills</b>: Enhancing verbal, non-verbal, and expressive language, foundational for <b>vocational training</b> success.</li>
                <li><b>Motor Skills Development</b>: Gross and fine motor skill enhancement through play and physical activities.</li>
                <li><b>Naturalistic Learning</b>: Learning through real-life contexts.</li>
                <li><b>Digital Literacy</b>: Confidence-building with technology and cognitive flexibility.</li>
                <li><b>Numeracy Skills</b>: Strengthening practical math and number sense.</li>
                <li><b>Inclusion Programs</b>: Social interaction and peer engagement within inclusive environments, preparing students for <b>vocational courses</b> in various settings.</li>
                <li><b>Art-Based Learning</b>: Promoting creativity, emotional regulation, and motor coordination.</li>

              </ul>
            </div>

            {/* <div className="text-center">
              <img src={Chart} className="img-fluid" alt="Numeracy Enhancement , Communication Skills , Digital Literacy , Manzil" />
            </div> */}
          </Col>
          <Col lg={12}>
            <div className="main-heading text-center mt-5">
              <span className="center">How It Works</span>

              {/* <p>
                Manzil students who are enrolled in the training program have
                access to the following services :
              </p> */}
              <p>Our process is simple, personalized, and parent-inclusive:</p>

            </div>
            <div className="mb-5">
              <ul>
                <li><b>Submit an Inquiry</b>: Fill out a short online form to get started.</li>
                <li><b>Screening & Assessment</b>: We evaluate the child's strengths, needs, and developmental profile.</li>
                <li><b>Personalized Plan (ILP)</b>: A customized plan is created to include skill-building, therapeutic inputs, and family goals.</li>
                <li><b>Service Delivery</b>: Individual sessions 1:1 or group-based, incorporating art-based learning, digital skills, life skills, and inclusion activities.</li>
                <li><b>Review & Evolve</b>: Monthly reviews and real-time progress tracking with families ensure that the ILP evolves as the child grows.</li>
              </ul>
            </div>
          </Col>
          <Col lg={12}>
            {/* <video
              src={BannerVideo}
              poster={videothum}
              autoPlay
              muted
              // playsInline
              loop
              className="w-100 h-100">
              <source src={BannerVideo} type="video/mp4" /> 
            </video> */}

            {/* <video
              src={BannerVideo}
              poster={videothum}
              autoPlay="true"
              muted
              loop
              className="w-100 h-100"
            /> */}
            {/* <ModalVideo
              channel="youtube"
              youtube={{ autoplay: true }}
              isOpen={isOpen}
              videoId="HgLniIYaxV0"
              onClose={() => setOpen(false)}
            />
            <button className="btn-primary" onClick={() => setOpen(true)}>
              VIEW DEMO
            </button> */}
            <YouTube
              videoId="HgLniIYaxV0"
              opts={opts}
              onReady={onPlayerReady}
            />
          </Col>
        </Row>
      </Container>
      <Footer />
      {/* <Button variant="primary" onClick={handleShow} className='enquiry-btn default-btn-orange border-0 px-3'>
        Enquiry
      </Button> */}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Enquiry Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Col lg={12}>
              <FloatingLabel
                controlId="floatingInput"
                label="Name"
                className="mb-3"
              >
                <Form.Control type="text" placeholder="Name" />
              </FloatingLabel>
            </Col>
            <Col lg={12}>
              <FloatingLabel
                controlId="floatingPassword"
                label="Email"
                className="mb-3"
              >
                <Form.Control type="text" placeholder="Email" />
              </FloatingLabel>
            </Col>
            <Col lg={12}>
              <FloatingLabel
                controlId="floatingPassword"
                label="Phone"
                className="mb-3"
              >
                <Form.Control type="text" placeholder="Phone" />
              </FloatingLabel>
            </Col>

            <Col lg={12}>
              <FloatingLabel
                controlId="floatingTextarea2"
                label="Message"
                className="mb-3"
              >
                <Form.Control
                  as="textarea"
                  placeholder="Leave a comment here"
                  style={{ height: "100px" }}
                />
              </FloatingLabel>
            </Col>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" className="default-btn-orange border-0">
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
